<template>
  <div>
    <CRow>
      <CCol>
        <CCard>
          <CCardBody>
            <div>
                <CRow>
                  <CCol>
                    <CInput
                      v-model="searchString"
                      placeholder="Search"
                      horizontal
                    ></CInput>
                  </CCol>
                  <!-- <CCol>
                    <CSelect
                      v-if="postType == 'all'"
                      :value.sync="filtersts"
                      horizontal
                      :options="statuses"
                      placeholder="Select Status"
                    />
                  </CCol> -->
                  <CCol>
                    <button
                      type="button"
                      class="btn btn-primary float-xl-right"
                      @click="newGrade"
                    >
                      New Grade
                    </button>
                  </CCol>
                </CRow>
              </div>

            <CDataTable
              :items="items"
              :fields="fields"
             
               :items-per-page="itemsPerPage"
                hover
                sorter
                
                ref="vuetable"
                pagination
                :responsive="false"
                @page-change="pagechange"
                @pages-change="pageschange"
            >
  <template #index="data">
       <td>
         {{data.index +1}}
         </td>
     </template>
    
      <template #grade="{ item }">
                  <td v-if="item.grade">
                    {{
                     item.grade.name
                    }}
                  </td>
                  <td v-else>--</td>
                </template>

       <template #ordercode="{ item }">
                  <td v-if="item.grade">
                    {{
                     item.grade.orderCode
                    }}
                  </td>
                  <td v-else>--</td>
                </template>

         <template #description="{ item }">
                  <td v-if="item.grade">
                    {{
                     item.grade.description
                    }}
                  </td>
                  <td v-else>--</td>
                </template>

      <template #stream="{ item }">
                  <td v-if="item.stream">
                    {{
                     item.stream.name
                    }}
                  </td>
                  <td v-else>--</td>
                </template>

        <template #category="{ item }">
                  <td v-if="item.category">
                    {{
                     item.category.name
                    }}
                  </td>
                  <td v-else>--</td>
                </template>

    

             <template #createdTime="{ item }">
                  <td v-if="item.grade">
                    {{
                      item.grade.createdTime
                        | dateParse()
                        | dateFormat("MMM DD, YYYY h:mm A")
                    }}
                  </td>
                  <td v-else>--</td>
                </template>

                 <template #modifiedTime="{ item }">
                  <td v-if="item.grade">
                    {{
                      item.grade.modifiedTime
                        | dateParse()
                        | dateFormat("MMM DD, YYYY h:mm A")
                    }}
                  </td>
                  <td v-else>--</td>
                </template>

              <template #show_details="{item}">
                <td class="py-2">
                  <CDropdown togglerText="Actions" color="info">
                    <CDropdownItem
                      :to="{name: 'ViewGrade', params: {gradeId: item.grade.gradeId, mode: 'view'}}"
                    >View</CDropdownItem>
                    <!-- <CDropdownItem
                      :to="{name: 'Grade', params: {gradeId: item.gradeId, mode: 'edit'}}"
                    >Edit</CDropdownItem> -->
                    <ConfirmationModal
                      :parent="$refs.modalArea"
                      :description="'Are you sure to Delete'"
                      @on:ok="deleteStream(item.grade.gradeId)"
                    ></ConfirmationModal>
                  </CDropdown>
                </td>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <div ref="modalArea"></div>
  </div>
</template>
<script>
const fields = [
  { key: "index",label: "#"},
  { key: "grade", label: "Grade Name", _style: "min-width:100px;" },
  { key: "ordercode", label: "Order Code", _style: "min-width:50px;" },
  { key: "description", _style: "min-width:100px;" },
  { key: "stream", _style: "min-width:100px;" },
  { key: "category", _style: "min-width:100px;" },
  { key: "createdTime",label: "Created Date & Time", _style: "min-width:100px;" },
  { key: "modifiedTime",label: "Modified Date & Time" ,_style: "min-width:100px;" },
  {
    key: "show_details",
    label: "",
    _style: "width:1%",
    sorter: false,
    filter: false,
  },
];
import ConfirmationModal from "../../containers/ConfirmationModal";
export default {
  name: "Grades",
  components: {
    ConfirmationModal,
  },
  data() {
    return {
        paginationLastPage: 0,
      paginatedCurrentPage: 0,
      paginationNextPage: 0,
      itemsPerPage: 20,
      searchString: "",
      items: [],
      fields,
      details: [],
      collapseDuration: 0,
    };
  },
  methods: {
     nextPage() {
      return ++this.paginationNextPage;
    },
    pagechange(activePage) {
      console.log("activePage", activePage);
      if (this.paginationLastPage - activePage < 1) {
        console.log("calling next page");
        this.getGrades(this.nextPage());
      }
    },
    pageschange(totalPages) {
      console.log("totalPages", totalPages);
      this.paginationLastPage = totalPages;
    },
    deleteStream(gradeId) {
      console.log("delete called with", gradeId);
      this.apiGetSecure(
        process.env.VUE_APP_API_HOST +
          "/web/secure/delete/grade/" +
          gradeId
      )
        .then((response) => response.json())
        .then((data) => {
          this.getGrades();
               this.$nextTick(() => {
             this.$refs.vuetable.refresh();
           });
           window.location.reload();
        });
    },
    // getGrades() {
    //   this.apiGetSecure(process.env.VUE_APP_API_HOST + "/web/secure/grades")
    //     .then((response) => response.json())
    //     .then((data) => (this.items = data));
    // },
    
     getGrades(page, reload = false) {
      var url = process.env.VUE_APP_API_HOST + "/web/secure/grades";
      url = url + "?page=" + (page || 0);
       if (this.searchString) {
        url = url + "&search=" + this.searchString;
      }
      this.apiGetSecure(url)
        .then((response) => response.json())
        .then((data) => {
          if (reload == true) {
            this.paginationNextPage = 0;
          }
          if (this.paginationNextPage > 0) {
            this.items = this.items.concat(data);
            console.log("appending items");
          } else {
            this.items = data;
            if (this.items.length <= this.itemsPerPage) {
              console.log("calling next page due to same page size");
              this.getGrades(this.nextPage());
            }
          }
        });
    },
    newGrade() {
      this.$router.push({ name: "New Grade", params: { mode: "new" } });
    },
  },
  mounted() {
    this.getGrades();
  },
   watch: {
    searchString(newString, oldString) {
      this.getGrades(0, true);
      console.log("newString", newString, "oldString", oldString);
    },
    filtersts(newString, oldString) {
      this.getGrades(0, true);
      console.log("newString", newString, "oldString", oldString);
    },
  },
};
</script>
<style >
/* .header-content {
  position: absolute;
  bottom: 0;
  left: 0;
  
  width: 100%;
} */

.header {
  display: table-cell;
  vertical-align: bottom;
}
</style>